/**
 * Header for Bryntum demos
 */

import React, { Component, Fragment, ReactNode } from 'react';
import { BryntumFullscreenButton } from './BryntumFullscreenButton';
import { BryntumButton } from './BryntumButton';
import { BryntumThemeCombo } from './BryntumThemeCombo';

export type BryntumDemoHeaderProps = {
    /**
     * Insert children to demo header
     */
    children?: ReactNode | ReactNode[]
    /**
     * Demo title for header
     */
    title?: string
    /**
     * Display <BryntumThemeCombo/> component when set to `true`
     */
    themeCombo?: boolean
}

export class BryntumDemoHeader extends Component<BryntumDemoHeaderProps> {

    static defaultProps: Partial<BryntumDemoHeaderProps> = {
        themeCombo : true
    };

    getLink(): string {
        // Convert:
        // https://bryntum.com/products/schedulerpro/examples-scheduler/frameworks/react/javascript/basic/build/
        // https://bryntum.com/products/schedulerpro/examples/frameworks/react/javascript/basic/build/
        // To:
        // https://bryntum.com/products/schedulerpro/examples/#example-examples-scheduler-frameworks-react-basic
        // https://bryntum.com/products/schedulerpro/examples/#example-frameworks-react-basic

        const match = /(.*?\/)(examples.*?\/frameworks\/.*?)\/(build|out|dist)/.exec(document.location.href);
        return match ? `${match[1]}examples/#example-${match[2].replace(/\//gm, '-').replace('examples-frameworks', 'frameworks')}` : '#';
    }

    getTitle(): string {
        return this.props.title || document.title.split(' - ')[1] || document.title;
    }

    shouldComponentUpdate(nextProps: Readonly<BryntumDemoHeaderProps>): boolean {
        return nextProps.title !== this.props.title;
    }

    render(): ReactNode {
        return (
            <Fragment>
                <header className="demo-header">
                    <div id="title-container">
                        <a id="title" href={this.getLink()}>
                            <h1>{this.getTitle()}</h1>
                        </a>
                    </div>
                    {this.props.children}
                    {this.props.themeCombo && <BryntumThemeCombo />}
                    <BryntumButton
                        text="Download Trial"
                        href="https://bryntum.com/download/?product=schedulerpro"
                        cls="b-green b-raised"
                    />
                    <BryntumFullscreenButton />
                </header>
            </Fragment>
        );
    }
}
